import { ErrorOnLoadCurrenciesTemplate } from '@/components/templates'
import { BaseView } from '@/components/base'
import {
  ResetFirstDepositOnRouteEntry,
  FirstDepositAmountDisplay,
  FirstDepositConversionRate,
  FirstDepositNumberPad,
  FirstDepositButtonConfirmation,
  FirstDepositHeader,
  FirstDepositMaximumButton,
} from '@/features/savings/first-deposit'
import { useUserStore } from '@/store/useUserStore'
import useOffsets from '@/hooks/useOffsets'

export default function FirstDepositScreen() {
  const completeCurrencies = useUserStore(
    (state) => state.wallet?.completeCurrencies,
  )
  const offsets = useOffsets()

  if (!completeCurrencies?.length) return <ErrorOnLoadCurrenciesTemplate />

  return (
    <>
      <ResetFirstDepositOnRouteEntry />

      <BaseView
        flex={1}
        bgColor="background.screen"
        style={{
          height: '100vh',
          paddingTop: offsets.top + 70,
        }}
      >
        {/* Header */}
        <FirstDepositHeader />

        <BaseView flex={1} px={12} className="flex flex-col h-full">
          {/* Central area with amount display */}
          <BaseView
            align="center"
            gap={14}
            className="flex-1 flex flex-col justify-start"
            style={
              {
                // paddingTop: 28,
              }
            }
          >
            <BaseView gap={20} center>
              <FirstDepositAmountDisplay />
              <FirstDepositConversionRate />
              <FirstDepositMaximumButton />
            </BaseView>
          </BaseView>

          {/* Bottom area with keyboard and button */}
          <BaseView
            className="flex-shrink-0"
            style={{
              gap: 12,
            }}
          >
            <FirstDepositNumberPad />
            <div style={{ paddingBottom: offsets.bottom }}>
              <FirstDepositButtonConfirmation />
            </div>
          </BaseView>
        </BaseView>
      </BaseView>
    </>
  )
}
